exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".empty-message-container {\n    margin-top: 30%; \n    justify-content: center;\n    text-align: center;\n}\n\n.empty-message-container span {\n    text-align: center;\n}", ""]);

// exports
